<template>
  <header class="projects-header">
    <div class="projects-header_left">
      <h1 class="title">{{$t('menu.projects')}}</h1>
      <div v-if="isList && projects.length" @click="toggleAll" class="check-group">
        <checkAllIcon />
        <span class="check-number">{{checkedProjects.length}}</span>
        <span class="check-action">
          {{checkedProjects.length === projects.length ? $t('projects.projectsList.deselectAll') : $t('projects.projectsList.selectAll')}}
        </span>
      </div>
    </div>
    <div class="projects-header_right">
      <div class="view-cont"
           :class="{'view-cont_nomargin': !adminRole}">
        <p class="view-label">
          {{$t('projects.header.viewTitle')}}
        </p>
        <ul class="view-controls controls-list">
          <li class="view-control control-item">
            <button type="button"
                    @click="setActiveView('tile'); setCheckedProjects( [])"
                    :class="{'active-view': isTile}"
                    class="control-btn-new hover-blue-new hint-cont">
              <project-tile-icon></project-tile-icon>
              <p class="btn-hint btn-hint_light btn-hint_bottom">
                {{$t('projects.header.tileIcon')}}
              </p>
            </button>
          </li>
          <li class="view-control">
            <button type="button"
                    @click="setActiveView('list')"
                    :class="{'active-view': isList}"
                    class="control-btn-new hover-blue-new hint-cont">
              <projects-list-icon></projects-list-icon>
              <p class="btn-hint btn-hint_light btn-hint_bottom">
                {{$t('projects.header.listIcon')}}
              </p>
            </button>
          </li>
        </ul>
      </div>
      <ul class="controls-list header-controls" v-if="adminRole">
        <li class="control-item">
          <button type="button"
                  @click="checkDel"
                  v-if="isList && checkedProjects.length > 0"
                  class="control-btn-new hover-blue-new hint-cont">
            <del-icon></del-icon>
            <p class="btn-hint btn-hint_light btn-hint_bottom_right ">
              {{$t('projects.header.delete')}}
            </p>
          </button>
        </li>
        <li class="control-item">
          <button type="button"
                  @click="showCreateProjectPopup"
                  class="hint-cont btn-main-plus">
            <plus-icon></plus-icon>
            <p class="btn-hint btn-hint_light btn-hint_bottom_right ">
              {{$t('projects.header.addBtn')}}
            </p>
          </button>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
  import delIcon from '../../Svg/cart_control/delIcon'
  import plusIcon from '../../Svg/plusIcon'
  import projectTileIcon from '../../Svg/projects/projectTileIcon'
  import projectsListIcon from '../../Svg/projects/projectsListIcon'
  import checkAllIcon from '../../Svg/projects/checkAllIcon'
  import {projectsView} from "../../../mixins/projects/projectsView";
  import {delItem} from "../../../mixins/delItem";
  import {mapState, mapGetters, mapActions, mapMutations} from 'vuex'
  import {loaderMixin} from "../../../mixins/utils/loaderMixin";

  export default {
    name: 'projectsHeader',
    mixins: [projectsView, delItem, loaderMixin],
    components: {
      delIcon,
      plusIcon,
      projectTileIcon,
      projectsListIcon,
      checkAllIcon
    },
    computed: {
      ...mapState({
        checkedProjects: state => state.projects.checkedProjects,
        projects: state => state.projects.allProjects
      }),
      ...mapGetters({
        adminRole: 'auth/adminRole'
      }),
      checkedProjectsAll: {
        get() {
          return this.checkedProjects
        },
        set(val) {
          this.setCheckedProjects(val)
        }
      },
    },
    methods: {
      ...mapMutations({
        setCheckedProjects: 'projects/SET_CHECKED_PROJECTS'
      }),
      ...mapActions({
        delProject: 'projects/delProject',
      }),
      toggleAll() {
        if (this.checkedProjectsAll.length === this.projects.length) {
          this.checkedProjectsAll = []
        } else {
          this.checkedProjectsAll = this.projects
        }
      },
      showCreateProjectPopup() {
        this.showOverlay(true)
        this.showCreateProject(true)
      },
      checkDel() {
        let string = '';
        this.checkedProjects.forEach((item,i,arr) => {
          string += `${item.name}${(i !== arr.length - 1) ? ', ' : ''}`
        });
        this.showOverlay(true);
        this.showDelPopup(true);
        this.setDelItems(string)
      },
      async deleteItems() {
        this.showLoader();
        for (let i = 0; i < this.checkedProjects.length; i++) {
          let item = this.checkedProjects[i];
          await this.delProject(item.id)
        };
        this.setCheckedProjects([]);
        this.hideLoader()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .projects-header_left {
    display: flex;
  }

  .check-group {
    min-width: 150px;
    height: 40px;
    border: 1px solid rgba(16, 156, 241, 0.36);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.25px;
    color: #109CF1;

    svg {
      margin-right: 10px;
      margin-left: 18px;
    }

    .check-number {
      margin-right: auto;
    }

    .check-action {
      cursor: pointer;
      margin: 0 18px;
    }
  }

  .projects-header {
    position: sticky;
    top: 90px;
    z-index: 1;
    background: $lightGrey;
    padding: 20px 40px;
    box-shadow: inset 0px -1px 0px #D7E3EA;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .title {
    font-family: $msb;
    font-size: 18px;
    letter-spacing: .25px;
    color: $darkBlue;
    margin-right: 40px;
  }

  .projects-header_right {
    display: flex;
    align-items: center;
  }

  .active-view {
    background: white;
    filter: drop-shadow(0px 4px 12px rgba(0, 82, 127, 0.1));
  }

  .view-controls {
    display: flex;
    align-items: center;
    margin: 0 -10px;
  }

  .view-control {
    margin: 0 10px;
  }

  .view-cont {
    display: flex;
    align-items: center;
    margin-right: 80px;
  }

  .view-cont_nomargin {
    margin-right: 0;
  }

  .view-label {
    font-family: $mm;
    font-size: 14px;
    margin-right: 20px;
  }

  .header-controls {
    display: flex;
    align-items: center;
    margin: 0 -10px;

    .control-item {
      margin: 0 10px;
    }
  }
</style>
